import 'react-app-polyfill/ie9';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import createBrowserHistory from 'history/createBrowserHistory';

import moment from 'moment';
import 'moment/locale/en-gb';
import 'react-toastify/dist/ReactToastify.css';
import 'rc-slider/assets/index.css';
import './index.css';
import reducers from './reducers';
import App from './components/App.js';
import { unregister } from './registerServiceWorker';
import 'i18n';

moment.locale('en-gb');

export const store = createStore(reducers);

ReactDOM.render(
  <Provider store={store}>
    <Router history={createBrowserHistory()}>
      <App />
    </Router>
  </Provider>,
  document.getElementById('root'),
);
unregister();
